import { Route, NavigationGuardNext } from 'vue-router';
import { CHILD_CARE_EDIT_ROUTE_TYPES, careTypeRouteToGraphqlKey } from '@/apps/provider/profile/edit/lib/careTypeUtils';

const SUPPORTED_EDIT_TYPES = new Set<string>([...CHILD_CARE_EDIT_ROUTE_TYPES, 'pet_care', 'housekeeping', 'companion_care']);

export const requireSupportedProfileEditCareType = (to: Route, _from: Route, next: NavigationGuardNext) => {
  const careType = to.params.care_type;

  if (!careType || !SUPPORTED_EDIT_TYPES.has(careType)) {
    next({ name: 'provider-profile', params: { care_type: 'babysitter', sitter_uuid: to.params.sitter_uuid } });
    return;
  }

  if (!careTypeRouteToGraphqlKey[careType as keyof typeof careTypeRouteToGraphqlKey]) {
    next(false);
    return;
  }

  next();
};
